import { useCallback } from 'react';

import {
  InteractiveResponseProperties,
  SettingProps,
} from './interactive-response.constants';
import { getItemPayload } from './interactive-response-settings.utils';
import { DraftAction } from 'global/constants';
import { useBatchComponentUpdateContext } from 'approot/activity-builder/components/shared/batch-component-update.context';

export const useInteractiveResponseUpdate = ({
  id,
  sectionId,
}: SettingProps) => {
  const { loading, updateComponentProperties } =
    useBatchComponentUpdateContext();

  const handleUpdate = useCallback(
    (
      newProperties: InteractiveResponseProperties,
      options?: {
        draftAction?: DraftAction;
        isSaveImmediate?: boolean;
        onCompleted?: () => void;
      }
    ) => {
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          addDraftAction: options?.draftAction,
          componentData: {
            properties: {
              interactiveResponse: {
                ...newProperties.interactiveResponse,
                items: getItemPayload(newProperties.interactiveResponse.items),
              },
              dimensionData: newProperties.responseDimensionData || null,
            },
          },
        },
        properties: newProperties,
        typename: 'ActivitiesInteractiveResponseComponent',
        isSaveImmediate: options?.isSaveImmediate,
        onCompleted: options?.onCompleted,
      });
    },
    [id, sectionId, updateComponentProperties]
  );

  return {
    loading,
    handleUpdate,
  };
};
